"use client";

import * as React from "react";
import { useState } from "react";

import { X } from "lucide-react";

import { cn } from "@repo/ui/lib/utils";

type NotificationBarProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
  initialVisible?: boolean;
  dismissible?: boolean;
  onDismiss?: () => void;
  dismissButtonClassName?: string;
  dismissIconClassName?: string;
};

export function NotificationBar({
  children,
  initialVisible = true,
  dismissible = true,
  onDismiss,
  className,
  dismissButtonClassName,
  dismissIconClassName,
  ...divProps
}: NotificationBarProps) {
  const [isVisible, setIsVisible] = useState<boolean>(initialVisible);

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "w-full py-2 text-white shadow-lg sm:py-3 md:py-4",
        !className?.includes("bg-") && "bg-brand-cyan",
        className,
      )}
      {...divProps}
    >
      <div className="relative mx-auto flex max-w-7xl items-center justify-center px-3 pr-14 text-xs sm:px-4 sm:pr-20 sm:text-sm md:px-6 md:pr-24 md:text-base">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex-1 leading-snug">{children}</div>
        </div>

        {dismissible ? (
          <button
            onClick={() => {
              setIsVisible(false);
              onDismiss?.();
            }}
            aria-label="Dismiss message"
            className={cn(
              "absolute right-2 rounded-full p-1 transition-colors sm:right-4",
              dismissButtonClassName,
            )}
          >
            <X className={cn("h-4 w-4 sm:h-5 sm:w-5", dismissIconClassName)} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
